export const locale = {
  lang: 'de',
  data: {
    ROLE: {
      ACTIONTYPE: 'Okuma'
    } 
  }
}
